"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const PhoneInput = ({
  name,
  required,
  onChange,
  onBlur,
  onFocus,
  multipleChoice,
  data = {},
  langObj,
  lang = 'en'
}) => {
  const _langObj$area = langObj.area,
    area = _langObj$area === void 0 ? 'area' : _langObj$area,
    _langObj$phone = langObj.phone,
    phone = _langObj$phone === void 0 ? 'phone' : _langObj$phone;
  const selectRef = (0, _react.useRef)(null);
  const _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    isOpen = _useState2[0],
    setIsOpen = _useState2[1];
  const _useState3 = (0, _react.useState)(''),
    _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
    phoneCode = _useState4[0],
    setPhoneCode = _useState4[1];
  const _useState5 = (0, _react.useState)(''),
    _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
    phoneNum = _useState6[0],
    setPhoneNum = _useState6[1];
  const _useState7 = (0, _react.useState)([...multipleChoice]),
    _useState8 = (0, _slicedToArray2.default)(_useState7, 2),
    countryList = _useState8[0],
    setCountryList = _useState8[1];

  // 区号修改
  const phoneCodeChange = event => {
    const value = event.target.value.trim();
    let filterList = multipleChoice;
    if (value) {
      filterList = multipleChoice.filter(item => item.Code.indexOf(value) >= 0 || item.EnName.toUpperCase().indexOf(value.toUpperCase()) >= 0);
    }
    setPhoneCode(value);
    setCountryList([...filterList]);
  };
  // 区号列表点击
  const phoneCodeSelect = item => {
    setPhoneCode(item.Code);
    setIsOpen(false);
  };
  const valueFocus = event => {
    // phoneCodeChange(event);
    onFocus();
  };
  const closeDownList = event => {
    if (!selectRef.current.contains(event.target)) {
      setIsOpen(false);
    }
  };
  (0, _react.useEffect)(() => {
    document.addEventListener('click', closeDownList, false);
    return () => {
      document.removeEventListener('click', closeDownList, false);
    };
  }, []);
  (0, _react.useEffect)(() => {
    onChange(`${phoneCode}-${phoneNum}`);
  }, [phoneCode, phoneNum]);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)({
      'intl-form-item': true,
      'rno-form-item': true,
      'phone-area-input': true,
      'rno-form-required': required,
      'rno-form-status-error': data.isError
    })
  }, /*#__PURE__*/_react.default.createElement("label", {
    className: "form-component-label-s"
  }, name, required && /*#__PURE__*/_react.default.createElement("span", null)), /*#__PURE__*/_react.default.createElement("div", {
    className: "rno-form-controls"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "i-form-combo-mod",
    style: {
      width: '100%',
      display: 'flex'
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "i-form-combo-aside",
    style: {
      flex: 1
    },
    ref: selectRef
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)('rno-select rno-select-placeholder rno-select-full-width ', {
      'rno-select-open': isOpen
    })
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "phoneCode_box",
    onClick: () => setIsOpen(true)
  }, /*#__PURE__*/_react.default.createElement("i", {
    className: "phoneCode"
  }, "+"), /*#__PURE__*/_react.default.createElement("input", {
    placeholder: area,
    className: "rno-input",
    value: phoneCode,
    autoComplete: "off",
    onChange: phoneCodeChange,
    onFocus: valueFocus,
    onBlur: onBlur
  }), /*#__PURE__*/_react.default.createElement("i", {
    className: "rno-select-btn-caret"
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "rno-dropdown rno-select-dropdown rno-dropdown-bottom"
  }, /*#__PURE__*/_react.default.createElement("ul", {
    className: "rno-dropdown-menu"
  }, countryList.map((item, index) => /*#__PURE__*/_react.default.createElement("li", {
    className: "rno-dropdown-menu-item",
    onClick: () => phoneCodeSelect(item),
    key: `phone_input_${index}`
  }, /*#__PURE__*/_react.default.createElement("span", {
    style: {
      display: 'block'
    }
  }, lang === 'zh' ? item.Name : item.EnName, " + ", item.Code))))))), /*#__PURE__*/_react.default.createElement("div", {
    className: "i-form-combo-con",
    style: {
      flex: 3
    }
  }, /*#__PURE__*/_react.default.createElement("input", {
    className: "rno-input rno-input-full-width",
    placeholder: phone,
    value: phoneNum,
    onChange: event => {
      const value = event.target.value;
      setPhoneNum(value);
    },
    onFocus: onFocus,
    onBlur: onBlur
  }), /*#__PURE__*/_react.default.createElement("span", null), /*#__PURE__*/_react.default.createElement("div", {
    className: "rno-form-message"
  }, data.errMsg || '')))));
};
var _default = exports.default = PhoneInput;